import React from 'react';

/**
 * MNavbar is merged into the unified responsive Navbar component.
 * Returning null avoids any double logo or duplicate navigation headers.
 */
const MNavbar = () => {
	return null;
};

export default MNavbar;
